import React, { useCallback, useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import noImage from "../../assets/images/no_image.jpg";
import * as utils from "../../Utils/comman";
import DataTable from "react-data-table-component";
import moment from "moment";
import ReactDatePicker from "react-datepicker";
import { DocumentDownload } from "iconsax-react";

function View(props) {
  const { rowData } = props;
  const [page, setPage] = useState(1);
  const [itemList, setItemList] = useState([]);
  const [qty, setQty] = useState(rowData.item_qty);
  const [activeTab, setActiveTab] = useState("incoming");
  const [reset, setisReset] = useState("");
  // Filter states
  const [filters, setFilters] = useState({
    itemName: "",
    vendor_name: "",
    date_range: [null, null],
    qty: "",
    so_no: "",
    sp_name: "",
    distributor_name: "",
  });

  const countPerPage = 10;

  const handleBackClick = () => {
    props.onChange({ mode: "list" });
  };

  const fetchData = useCallback(() => {
    const apiUrl =
      activeTab === "incoming"
        ? "/sales/getmarketingstockList"
        : "/sales/getmarketingstockOutList";

    const bodyFormData = new FormData();

    // Common parameters
    bodyFormData.append("page", page);
    bodyFormData.append("id", "");
    bodyFormData.append("per_page", countPerPage);
    bodyFormData.append("marketing_material_id", rowData.id ? rowData.id : "");
    bodyFormData.append(
      "item_name",
      filters?.itemName ? filters?.itemName : ""
    );

    // Conditional filters based on activeTab
    if (activeTab === "incoming") {
      bodyFormData.append(
        "vendor_name",
        filters.vendor_name ? filters.vendor_name : ""
      );
    } else {
      bodyFormData.append("so_no", filters.so_no ? filters.so_no : "");
      bodyFormData.append("sp_name", filters.sp_name ? filters.sp_name : "");
      bodyFormData.append(
        "distributor",
        filters.distributor_name ? filters.distributor_name : ""
      );
    }

    // Date filter (common for both tabs)
    bodyFormData.append(
      "date_from",
      filters.date_range[0]
        ? moment(filters.date_range[0]).format("YYYY-MM-DD")
        : ""
    );
    bodyFormData.append(
      "date_to",
      filters.date_range[1]
        ? moment(filters.date_range[1]).format("YYYY-MM-DD")
        : ""
    );

    utils
      .callAPI("post", apiUrl, bodyFormData)
      .then((res) => {
        setItemList(res || []);
        setisReset(false);
      })
      .catch(() => {
        setItemList([]);
        setisReset(false);
      });
  }, [page, activeTab, filters]);

  useEffect(() => {
    fetchData();
  }, [page, activeTab]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleSearch = () => {
    fetchData();
  };

  const handleReset = () => {
    setFilters({
      itemName: "",
      vendor_name: "",
      date_range: [null, null],
      qty: "",
      so_no: "",
      sp_name: "",
      distributor_name: "",
    });
    setPage(1);
    setisReset(true);
  };

  useEffect(() => {
    if (reset) {
      fetchData();
    }
  }, [reset]);

  const handleDownload = () => {
    const apiUrl =
      activeTab === "incoming"
        ? "/sales/getmarketingstockList"
        : "/sales/getmarketingstockOutList";

    var bodyFormData = new FormData();
    bodyFormData.append("id", "");
    bodyFormData.append("page", 0);
    bodyFormData.append("per_page", 0);
    bodyFormData.append("marketing_material_id", rowData.id ? rowData.id : "");
    bodyFormData.append(
      "item_name",
      filters?.itemName ? filters?.itemName : ""
    );

    // Apply relevant filters
    if (activeTab === "incoming") {
      bodyFormData.append(
        "vendor_name",
        filters.vendor_name ? filters.vendor_name : ""
      );
    } else {
      bodyFormData.append("so_no", filters.so_no ? filters.so_no : "");
      bodyFormData.append("sp_name", filters.sp_name ? filters.sp_name : "");
      bodyFormData.append(
        "distributor",
        filters.distributor_name ? filters.distributor_name : ""
      );
    }

    // Date filters
    bodyFormData.append(
      "date_from",
      filters.date_range[0]
        ? moment(filters.date_range[0]).format("YYYY-MM-DD")
        : ""
    );
    bodyFormData.append(
      "date_to",
      filters.date_range[1]
        ? moment(filters.date_range[1]).format("YYYY-MM-DD")
        : ""
    );

    utils
      .callAPI("post", apiUrl, bodyFormData)
      .then((res) => {
        if (res?.result?.length > 0) {
          const csvHeader =
            activeTab === "incoming"
              ? "Sr.No.,Item Name,Vendor,Date,Quantity"
              : "Sr.No.,Item Name,SO No.,Distributor Name,SP Name,Outgoing Qty,Date";

          const csvRows = res.result.map((item, index) =>
            activeTab === "incoming"
              ? `${index + 1},${item.item_name},${item.vendor_type},${moment(
                  item.vendor_date
                ).format("DD-MM-yyyy")},${item.vendor_qty}`
              : `${index + 1},${item.item_name},${item.order_id},${
                  item.channel_partner_name
                },${item.spFirstName} ${item.spLastName},${item.qty},${moment(
                  item.vendor_date
                ).format("DD-MM-yyyy")}`
          );

          const csvContent = [csvHeader, ...csvRows].join("\n");
          generateCSV(csvContent, `Pop Gift - ${activeTab.toUpperCase()}.csv`);
        }
      })
      .catch((err) => {
        console.error("Error downloading CSV:", err);
      });
  };

  // CSV file generation function
  function generateCSV(csvContent, fileName) {
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  console.log();
  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header className="border-0 mb-0">
          {props.rowData && Object.keys(props.rowData).length > 0 ? (
            <h4>Item Details</h4>
          ) : (
            <h4></h4>
          )}
          <div className="card-header-action">
            <RB.Button variant="link" onClick={handleBackClick}>
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          {props.rowData && Object.keys(props.rowData).length > 0 ? (
            <RB.Row>
              <RB.Col md={3}>
                {rowData.item_image && (
                  <div className="profile-photo rounded mb-3">
                    <img
                      src={rowData.item_image || noImage}
                      className="img-fluid rounded"
                      alt="document"
                    />
                  </div>
                )}
              </RB.Col>
              <RB.Col md={9}>
                <RB.Row className="mb-3">
                  {rowData?.item_name && (
                    <RB.Col md={6}>
                      <span className="text-uppercase fw-bold small text-body-secondary">
                        Name
                      </span>
                      <p className="fw-medium text-sm fw-semibold">
                        {rowData?.item_name}
                      </p>
                    </RB.Col>
                  )}
                  {rowData.item_qty && (
                    <RB.Col md={6}>
                      <span className="text-uppercase fw-bold small text-body-secondary">
                        Quantity
                      </span>
                      <p className="fw-medium text-sm fw-semibold">{qty}</p>
                    </RB.Col>
                  )}
                </RB.Row>
              </RB.Col>
            </RB.Row>
          ) : (
            ""
          )}
          <RB.Tabs
            activeKey={activeTab}
            onSelect={(k) => {
              setActiveTab(k);
              setPage(1);
              handleReset(); // Reset filters when switching tabs
            }}
            className="w-100 "
          >
            <RB.Tab eventKey="incoming" title="POP GIFT INCOMING">
              <RB.Row className="mb-3">
                {props.rowData && Object.keys(props.rowData).length > 0 ? (
                  ""
                ) : (
                  <RB.Col md={3}>
                    <RB.Form.Control
                      type="text"
                      name="itemName"
                      placeholder="Item Name"
                      value={filters.itemName}
                      onChange={handleFilterChange}
                    />
                  </RB.Col>
                )}
                <RB.Col md={3}>
                  <RB.Form.Control
                    type="text"
                    name="vendor_name"
                    placeholder="Vendor"
                    value={filters.vendor_name}
                    onChange={handleFilterChange}
                  />
                </RB.Col>
                <RB.Col md={3}>
                  <ReactDatePicker
                    selectsRange
                    startDate={filters.date_range[0]}
                    endDate={filters.date_range[1]}
                    onChange={(dates) =>
                      setFilters({ ...filters, date_range: dates })
                    }
                    dateFormat="dd-MM-yyyy"
                    className="form-control"
                    placeholderText="Select Date Range"
                    isClearable
                  />
                </RB.Col>
                <RB.Col md={2} className="d-flex">
                  <RB.Button
                    variant="primary"
                    onClick={handleSearch}
                    className="me-2"
                  >
                    Search
                  </RB.Button>
                  <RB.Button variant="secondary" onClick={handleReset}>
                    Reset
                  </RB.Button>
                </RB.Col>
                <RB.Col>
                  <RB.Button
                    size="sm"
                    variant="primary"
                    className="btn-circle ms-2"
                    onClick={handleDownload}
                    disabled={itemList.result?.length == 0}
                  >
                    <DocumentDownload />
                  </RB.Button>
                </RB.Col>
              </RB.Row>

              <DataTable
                data={itemList?.result}
                columns={[
                  { name: "SR.NO", selector: (row, index) => index + 1 },
                  { name: "Item Name", selector: (row) => row.item_name },
                  { name: "Vendor", selector: (row) => row.vendor_type },
                  {
                    name: "Date",
                    selector: (row) =>
                      moment(row.vendor_date).format("DD-MM-yyyy"),
                  },
                  { name: "Qty", selector: (row) => row.vendor_qty },
                ]}
                highlightOnHover
                responsive
                pagination
                paginationServer
                paginationTotalRows={itemList.total}
                paginationPerPage={countPerPage}
                paginationComponentOptions={{
                  noRowsPerPage: true,
                }}
                striped
                onChangePage={(page) => setPage(page)}
                persistTableHead
                customStyles={{
                  head: {
                    style: {
                      fontSize: "0.875rem", // Adjust the font size as needed
                      fontWeight: "bold", // Adjust the font weight as needed
                    },
                  },
                }}
              />
            </RB.Tab>

            <RB.Tab eventKey="outgoing" title="POP GIFT OUTGOING">
              <RB.Row className="mb-3">
                {props.rowData && Object.keys(props.rowData).length > 0 ? (
                  ""
                ) : (
                  <RB.Col md={4}>
                    <RB.Form.Control
                      type="text"
                      name="itemName"
                      placeholder="Item Name"
                      value={filters.itemName}
                      onChange={handleFilterChange}
                    />
                  </RB.Col>
                )}
                <RB.Col md={4}>
                  <RB.Form.Control
                    type="text"
                    name="so_no"
                    placeholder="SO.No"
                    value={filters.so_no}
                    onChange={handleFilterChange}
                  />
                </RB.Col>
                <RB.Col md={4}>
                  <RB.Form.Control
                    type="text"
                    name="sp_name"
                    placeholder="SP Name"
                    value={filters.sp_name}
                    onChange={handleFilterChange}
                  />
                </RB.Col>
                <RB.Col md={4} className="mt-2">
                  <RB.Form.Control
                    type="text"
                    name="distributor_name"
                    placeholder="Distributor"
                    value={filters.distributor_name}
                    onChange={handleFilterChange}
                  />
                </RB.Col>
                <RB.Col md={4} className="mt-2">
                  <ReactDatePicker
                    selectsRange
                    startDate={filters.date_range[0]}
                    endDate={filters.date_range[1]}
                    onChange={(dates) =>
                      setFilters({ ...filters, date_range: dates })
                    }
                    dateFormat="dd-MM-yyyy"
                    className="form-control"
                    placeholderText="Select Date Range"
                    isClearable
                  />
                </RB.Col>
                <RB.Col md={4} className="d-flex mt-2">
                  <RB.Button
                    variant="primary"
                    onClick={handleSearch}
                    className="me-2"
                  >
                    Search
                  </RB.Button>
                  <RB.Button variant="secondary" onClick={handleReset}>
                    Reset
                  </RB.Button>
                  <RB.Button
                    size="sm"
                    variant="primary"
                    className="btn-circle ms-2"
                    onClick={handleDownload}
                    disabled={itemList.result?.length == 0}
                  >
                    <DocumentDownload />
                  </RB.Button>
                </RB.Col>
              </RB.Row>

              <DataTable
                data={itemList?.result}
                columns={[
                  { name: "SR.NO", selector: (row, index) => index + 1 },
                  { name: "Item Name", selector: (row) => row.item_name },
                  { name: "SO. NO", selector: (row) => row.order_id },
                  {
                    name: "Distributor Name",
                    selector: (row) => row.channel_partner_name,
                  },
                  {
                    name: "SP. Name",
                    selector: (row) => `${row.spFirstName} ${row.spLastName}`,
                    width: "190px",
                  },
                  { name: "Outgoing Qty", selector: (row) => row.qty },
                  {
                    name: "Date",
                    selector: (row) =>
                      moment(row.vendor_date).format("DD-MM-yyyy"),
                  },
                ]}
                highlightOnHover
                responsive
                pagination
                paginationServer
                paginationTotalRows={itemList.total}
                paginationPerPage={countPerPage}
                paginationComponentOptions={{
                  noRowsPerPage: true,
                }}
                striped
                onChangePage={(page) => setPage(page)}
                persistTableHead
                customStyles={{
                  head: {
                    style: {
                      fontSize: "0.875rem", // Adjust the font size as needed
                      fontWeight: "bold", // Adjust the font weight as needed
                    },
                  },
                }}
              />
            </RB.Tab>

            <RB.Button
              variant="success"
              className="ms-3"
              onClick={() => console.log("Button Clicked")}
            >
              Action Button
            </RB.Button>
          </RB.Tabs>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default View;
